// Import UI Components
import { Icon, Tooltip } from '@geneui/components';
import { RoutesList } from 'routes';
import CopyToClipboard from 'components/common/CopyToClipboard';
import TittleLink from 'components/common/TittleLink';
// Import Services
import { Helpers } from 'services';
// Import Constants
import { l, ReportTypesLabels, ReportStateLabels, DataTableColumnsCustomTypes } from 'constants/common';

const { REPORT_EXECUTED_LIST } = RoutesList;

const { customMomentWithoutTimezoneConversion } = Helpers;
const getReportType = (type, t) => {
    switch (type) {
        case ReportTypesLabels.Report:
            return (
                <div className="crm-object-type-label">
                    <Icon type="bc-icon-crm-standart-report crm-object-type-icon dynamic" />
                    <span>{t(l.Report)}</span>
                </div>
            );
        case ReportTypesLabels.CustomReport:
            return (
                <div className="crm-object-type-label">
                    <Icon type="bc-icon-crm-custom-report crm-object-type-icon static" />
                    <span className="ellipsis-text">{t(l.CustomReport)}</span>
                </div>
            );
        case ReportTypesLabels.CompositeReport:
            return (
                <div className="crm-object-type-label">
                    <Icon type="bc-icon-composite-report crm-object-type-icon static" />
                    <span className="ellipsis-text">{t(l.CompositeReport)}</span>
                </div>
            );
        case ReportTypesLabels.CustomerJourneyReport:
            return (
                <div className="crm-object-type-label">
                    <Icon type="bc-icon-cj-report crm-object-type-icon static" />
                    <span className="ellipsis-text">{t(l.CustomerJourneyReport)}</span>
                </div>
            );
        default:
    }
};

const DataTableColumnsConfigs = (t, partnerDateTimeFormat) => {
    return {
        columns: [
            {
                text: t(l.ReportId),
                dataKey: 'ReportId',
                sortable: true,
                // eslint-disable-next-line react/prop-types
                colRenderer: (id) => <CopyToClipboard>{id}</CopyToClipboard>,
            },
            {
                text: t(l.Title),
                dataKey: 'Name',
                sortable: true,
                isPermanent: true,
                // eslint-disable-next-line react/prop-types
                colRenderer: (Name, _, row) => {
                    const { ReportId, ReportType, isViewMode } = row?.data ?? {};
                    return (
                        <div className="crm-list-column-title-icon-components">
                            <TittleLink
                                path={REPORT_EXECUTED_LIST}
                                isClickable={!isViewMode}
                                name={Name}
                                queryParams={{ reportId: ReportId, reportType: ReportType }}
                            />
                        </div>
                    );
                },
            },
            {
                text: t(l.ReportType),
                dataKey: 'ReportType',
                sortable: true,
                colRenderer: (type) => (
                    <Tooltip text={t(l[ReportTypesLabels[type]])}>
                        <div>{getReportType(type, t)}</div>
                    </Tooltip>
                ),
            },
            {
                text: t(l.State),
                dataKey: 'IsUsed',
                sortable: false,
                colRenderer: (isUsed) => (
                    <div className={`crm-used-or-not-used-badge-cnt crm-used-or-not-used-label-${isUsed}`}>
                        {isUsed ? t(l.Used) : t(l.NotUsed)}
                    </div>
                ),
            },
            {
                text: t(l.User),
                dataKey: 'CreatedBy.Name',
                sortable: true,
            },
            {
                type: DataTableColumnsCustomTypes.Date,
                text: t(l.CreatedDate),
                dataKey: 'CreatedDate',
                sortable: true,
                formatter: (CreatedDate) => {
                    return customMomentWithoutTimezoneConversion(CreatedDate).format(partnerDateTimeFormat);
                },
            },
            {
                text: t(l.LastModifier),
                dataKey: 'ModifiedBy.Name',
                sortable: true,
            },
            {
                type: DataTableColumnsCustomTypes.Date,
                text: t(l.ModifiedDate),
                dataKey: 'ModifiedDate',
                sortable: true,
                formatter: (ModifiedDate) => {
                    return customMomentWithoutTimezoneConversion(ModifiedDate).format(partnerDateTimeFormat);
                },
            },
            {
                text: t(l.Status),
                dataKey: 'State',
                sortable: true,
                colRenderer: (state) => (
                    <div className={`crm-report-state-badge-cnt crm-report-state-label-${state}`}>
                        {t(ReportStateLabels[state])}
                    </div>
                ),
            },
            {
                text: t(l.ExecutionsSelfComposite),
                dataKey: 'SelfExecutionCount',
                sortable: false,
                colRenderer: (SelfExecutionCount, _i, { data }) =>
                    SelfExecutionCount + '/' + data.CompositeExecutionCount,
            },
        ],
    };
};

const modalsStateSetDictKeys = {
    deleteReport: 'deleteReport',
    stopScheduleReport: 'stopScheduleReport',
    infoReport: 'infoReport',
    executeReport: 'executeReport',
    editReport: 'editReport',
    archiveReport: 'archiveReport',
    unarchiveReport: 'unarchiveReport',
};

export { DataTableColumnsConfigs, modalsStateSetDictKeys };
